import { FC, useContext, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ThemeContext } from '../../context/data/ThemeContext';

interface IProps {
    children?: any,
    [key: string]: any,
}

export const HeaderOrgLogo: FC<IProps> = ({children}) => {
    const { t } = useTranslation();
    const { setOrgLogo } = useContext(ThemeContext);

    useEffect(() => {
        if (children) {
            setOrgLogo(t(children));
        }

        return () => {
            setOrgLogo('');
        };
    }, [children]);

    return null;
}